import { type DeviceItem, useLocaleStore } from '@/stores'
import { GearType } from '@rapoo/device-sdk'
import { computed, ref } from 'vue'

export function useDpiData(itemRef: { value: DeviceItem }) {
  const device = computed(() => itemRef.value.original)
  const { t } = useLocaleStore()

  const features = computed(() => device.value.features)

  const currentConfig = computed(() => device.value.currentConfig.index)

  // DPI档位
  const gears = ref<GearType[]>()
  const getGears = async () => {
    const dpi = features.value.dpi
    if (dpi) {
      const baseGears = await dpi.getGears(currentConfig.value)
      gears.value = baseGears.filter((gear) => gear.enable)
    }
  }

  // 当前档位
  const currentGearIndex = ref<number>()
  const getCurrentGear = async () => {
    const dpi = features.value.dpi
    if (dpi) {
      currentGearIndex.value = await dpi.getCurrentGear(currentConfig.value)
    }
  }
  const currentGear = computed(() => {
    // 第一个档位索引可能为 0，不能按假值处理。
    if (currentGearIndex.value == null) {
      return null
    }
    const gear = gears.value?.[currentGearIndex.value]
    if (!gear) {
      return null
    }
    return `x${gear.x},y${gear.y}`
  })

  const initDpiData = async () => {
    if (device.value.manifest.type === 'mouse') {
      await getGears()
      await getCurrentGear()
    }
  }

  const dpiData = computed(() => {
    if (device.value.manifest.type !== 'mouse') {
      return null
    }
    const data = []
    if (gears.value?.length) {
      // 档位数
      data.push({
        name: t('home.overview.dpiData.gearCount'),
        value: gears.value.length,
      })
    }
    if (currentGear.value) {
      // 当前档位
      data.push({
        name: t('home.overview.dpiData.currentGear'),
        value: currentGear.value,
      })
    }

    if (!data.length) return null

    return {
      title: t('home.overview.dpiData.title'),
      data,
    }
  })

  return {
    dpiData,
    initDpiData,
  }
}
